module.exports = __webpack_public_path__ + "static/MC_steps_nuevos_FISICA_7_B-e607ddd2ee3b4cb62fda7483f6c86cdc.gif";